<template>
    <spinner v-show="dataLoading"></spinner>
    <div v-show="!dataLoading">
        <div id="mini-chart"></div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useRequestInlineTemplate } from '../mixins/RequestInlineTemplate';

const props = defineProps({
    symbol: {
        type: String,
        required: true
    },
    title: String
});

const requestInlineTemplate = useRequestInlineTemplate();
const dataLoading = ref(true);
const gChart = ref(null);
const feed = ref(null);

const updateTitle = () => {
    gChart.value.setTitle({
        text: props.title,
        useHTML: true,
        style: {
            fontFamily: 'Roboto'
        }
    });
};

const createChart = () => {
    const charts = window.Barchart.RealtimeWidgets.Charts;

    dataLoading.value = true;

    requestInlineTemplate.requestChartInlineTemplate(props.symbol)
        .then(() => {
            feed.value = charts.initFeed(charts.BarchartSiteDataFeed, {
                baseUrl: {
                    timeseries: '/api/proxies/timeseries'
                },
                defaultTemplate: '/mini-chart.def.json',
                // Override fetch method to include credentials For Edge 17
                async fetch(kind, relativeUrl) {
                    const baseUrl = this.baseUrl[kind];
                    const response = await fetch(`${baseUrl}${relativeUrl}`, {
                        credentials: 'include'
                    });

                    return await response.text();
                }
            });

            feed.value.ready()
                .then(() => {
                    dataLoading.value = false;

                    gChart.value = feed.value.addChart('mini-chart', {
                        symbol: props.symbol
                    });

                    if (props.title) {
                        updateTitle();
                    }
                })
        });
};

const updateChart = () => {
    dataLoading.value = true;
    requestInlineTemplate.requestChartInlineTemplate(props.symbol)
        .then(() => {
            gChart.value.change({
                id: 'MainPlot',
                context: {
                    symbol: props.symbol
                }
            });

            if (props.title) {
                updateTitle();
            }

            dataLoading.value = false;
        });
}

watch(() => props.symbol, () => {
    updateChart();
});

onMounted(() => {
    createChart();
});
</script>
